import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "../../../../../assets/svg/close.svg";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    configureBrands,
    configRecommendationFilter,
    cleanupData,
    switchMainTab,
    getConfigRecommendationFilterList,
} from "../../../../../actions/insightsRecommendationActions";
import moment from "moment";

const Settings = (props) => {
    const { closeSettings } = props;
    // const queryLists = useSelector((state) => state.insightsRecommendationReducer.queryLists);
    const queryLists = useSelector((state) => state.filterSettingReducer.topicsTree);
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const platforms = useSelector((state) => state.filterSettingReducer.platformsActive);
    const countries = useSelector((state) => state.filterSettingReducer.locationsActive);
    const languages = useSelector((state) => state.filterSettingReducer.languagesActive);
    // const topicsObject = useSelector((state) => state.filterSettingReducer.topicsObject);

    const initialState = (topicType) => {
        if (!topicType) return null;
        // let [value] = queryLists?.filter((obj) => {
        let value = queryLists
            ?.filter((obj) => {
                return [topicType[0]?.topic_id || "", topicType?.id || ""].includes(obj.id);
            })
            ?.map((obj) => {
                return {
                    value: obj,
                    label: obj.name,
                };
            });
        // return value;
        return value[0];
    };

    const [brandTopic, setBrandTopic] = useState(() => initialState(brandTopicObj));
    const [competitorTopic, setCompetitorTopic] = useState(() => initialState(competitorTopicObj));

    const dispatch = useDispatch();

    const customMultiTopicStyles = {
        control: (styles) =>
            props.editAlert
                ? { ...styles, backgroundColor: "#EFF5FC", paddingLeft: "4px", border: "none" }
                : { ...styles, backgroundColor: "#F7F7F7", paddingLeft: "4px", border: "none" },
        valueContainer: (provided, state) =>
            props.editAlert
                ? {
                      ...provided,
                      display: "flex",
                      maxHeight: 100,
                      maxWidth: 870,
                      paddingTop: 5,
                      backgroundColor: "#EFF5FC",
                      color: "#112C5A",
                      overflowY: "auto",
                  }
                : {
                      ...provided,
                      display: "flex",
                      maxHeight: 140,
                      maxWidth: 870,
                      paddingTop: 5,
                      backgroundColor: "#F7F7F7",
                      color: "#112C5A",
                      overflowY: "auto",
                  },
        option: (provided, state) => ({
            ...provided,
            color: "#1f2f3d",
            backgroundColor: state.isSelected ? "#01bfa3" : "inherit",
            "&:hover": {
                ...provided,
                color: state.isSelected ? "#fff" : "#1f2f3d",
                backgroundColor: state.isSelected ? "#01bfa3" : "rgba(1, 191, 163, .2)",
            },
        }),
    };

    const competitorOptions = queryLists
        .filter((obj) => obj.id !== brandTopic?.value?.id)
        ?.map((obj) => {
            return {
                value: obj,
                label: obj.name,
            };
        });

    const brandOptions = queryLists
        .filter((obj) => obj.id !== competitorTopic?.value?.id)
        ?.map((obj) => {
            return {
                value: obj,
                label: obj.name,
            };
        });

    const handleChangeBrand = (e) => {
        setBrandTopic(e);
    };

    const handleChangeCompetitor = (e) => {
        setCompetitorTopic(e);
    };

    const handleSave = async () => {
        if (brandTopic == null && competitorTopic == null) {
            toast.error("Please configure brand topic or competitor topic");
            return;
        }
        let params = {};
        if (brandTopic != null) params.own_brand_topic = brandTopic.value;

        if (competitorTopic != null) params.competitor_brand_topic = competitorTopic.value;
        //call api

        dispatch(configureBrands(params));

        let param = {
            filter: {
                own: {},
                competitor: {},
            },
        };

        if (brandTopic?.value) {
            let params1 = getSearchParams({ topic_data: brandTopic.value, countries, platforms, languages });
            params1.image_analytics_types = [];
            param.filter.own = JSON.parse(JSON.stringify(params1));
        }
        if (competitorTopic?.value) {
            let params2 = getSearchParams({ topic_data: competitorTopic.value, countries, platforms, languages });
            params2.image_analytics_types = [];
            param.filter.competitor = JSON.parse(JSON.stringify(params2));
        }

        // params1.image_analytics_types = [];
        // params2.image_analytics_types = [];
        // param.filter.own = JSON.parse(JSON.stringify(params1));
        // param.filter.competitor = JSON.parse(JSON.stringify(params2));

        dispatch(cleanupData());
        dispatch(switchMainTab("home"));
        await dispatch(configRecommendationFilter(param));
        dispatch(getConfigRecommendationFilterList());
        closeSettings();
        // toast.success("topics configured successfully"); // called inside api
    };

    return (
        <div className="settings__container">
            <div className="top__section">
                <div className="heading__block">
                    <div className="insights__heading settings">Settings</div>
                    <CloseIcon className="close__icon" onClick={closeSettings} />
                </div>
            </div>
            <div className="main__content__wrapper">
                <p>Configure your brand and your competitor</p>

                <div className=" dropdown__container">
                    <p className="field__name">Select Brands</p>
                    <Select
                        className="basic-single select-brand"
                        placeholder="Select Brand"
                        classNamePrefix="select"
                        defaultValue={brandTopic}
                        isSearchable
                        // hideSelectedOptions={false}
                        isClearable
                        options={brandOptions}
                        onChange={(e) => {
                            handleChangeBrand(e);
                        }}
                        maxMenuHeight={120}
                        styles={customMultiTopicStyles}
                        components={{ IndicatorSeparator: () => null }}
                    />
                </div>
                <div className=" dropdown__container">
                    <p className="field__name">Select Competitor</p>
                    <Select
                        className="basic-single select-competitor"
                        placeholder="Select Competitor"
                        classNamePrefix="select"
                        defaultValue={competitorTopic}
                        isSearchable
                        // hideSelectedOptions={false}
                        // name="alerts"
                        isClearable
                        options={competitorOptions}
                        onChange={(e) => {
                            handleChangeCompetitor(e);
                        }}
                        // menuIsOpen
                        maxMenuHeight={120}
                        styles={customMultiTopicStyles}
                        components={{ IndicatorSeparator: () => null }}
                    />
                </div>
                <div className="action__footer">
                    <button className="button back__button" onClick={closeSettings}>
                        Cancel
                    </button>
                    <button className="button" onClick={handleSave}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Settings;

export const getFormattedTopic = (topicObj) => {
    let subtopicIds = topicObj.subtopics.map((subTopic) => subTopic.subtopic_id);

    let subtopicNames = topicObj.subtopics.map((subTopic) => {
        let id = subTopic.subtopic_id;
        let name = subTopic.subtopic_name;
        return {
            id,
            name,
        };
    });

    return {
        topic_id: topicObj.id,
        name: topicObj.name,
        subtopicIds,
        subtopicNames,
    };
};

export const getSearchParams = ({ topic_data, countries, platforms, languages }) => {
    let params = {};
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    params.location = countries.map((country) => country.id);
    params.language = languages.map((lg) => lg.id);
    params.platform = platforms.map((plt) => plt.id);
    // params.start_date = moment().tz(tz).subtract(7, "days").startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    // params.end_date = moment().tz(tz).subtract(1, "days").endOf("day").format("YYYY-MM-DDTHH:mm:ss");
    params.duration = "7";
    params.apply_exclusion = "yes";
    // params.product_attribute_categories = [];
    // params.data = 1;
    let formattedTopic = getFormattedTopic(topic_data);
    params.topic_data = [formattedTopic];

    return params;
};
